import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { searchAddress } from "src/apis/addressApi";
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";
import useUiuxStore from "src/store/useUiuxStore";
import AddressItem from "src/components/common/form/address/AddressItem";
import { InputForm } from "src/components/common/form/input/InputForm"
import { SearchForm } from "src/components/common/modal/SearchForm";
import ModalWrapper from "../ModalWrapper";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
export const AddressModal = () => {

    const pageSize = 10;
    const pageBlockSize = 10;

    const { setAddressModalVisible, addressModalProps } = useUiuxStore();
    const { setLoadingSpinner } = useLoadingSpinnerStore();

    const [search, setSearch] = useState('');

    const [totalPages, setTotalPages] = useState(1);
    const [pageList, setPageList] = useState([1]);
    const [curPage, setCurPage] = useState(1);

    const [addressList, setAddressList] = useState<AddressJusoDto[]>([]);
	const [processMessage, setProcessMessage] = useState('');

    useEffect(() => {
        if (search !== '') {
            fetchData();
        }
    }, [curPage])

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);
        const data = await searchAddress(search, curPage, pageSize);

        const { juso, common } = data.data.results;
        if (!juso) {
			console.log(data.data.results);
			setProcessMessage(data.data.results.common.errorMessage);
			setLoadingSpinner(false);	
			return;
		}else if(juso.length === 0){
			setProcessMessage('검색 결과가 없습니다.');
			setLoadingSpinner(false);	
			return;
		}else{
			setProcessMessage('');
		}
        const _totalPages = Math.ceil(parseInt(common.totalCount) / pageSize);

        setTotalPages(_totalPages);
        setPageList(getBlock(curPage).filter(value => value <= _totalPages));
        setAddressList(juso);
        setLoadingSpinner(false);
    }, [curPage, search])


    const getBlock = (page: number): Array<number> => {
        const lowerBound = Math.floor((page - 1) / 10) * 10 + 1;

        return Array.from({ length: pageBlockSize }, (_, index) => lowerBound + index);
    }

    const handleSearchClick = useCallback(async () => {
        if (search.trim() === '') {
            setProcessMessage("검색어를 입력해주세요.");
            return;
        }

        fetchData();
    }, [search])

    const handlePrevClick = () => {
        if (curPage < 2) return;
        setCurPage(prev => prev - 1);
    }
    const handleNextClick = () => {
        if (curPage === totalPages) return;
        setCurPage(prev => prev + 1);
    }
    const handlePageClick = (page: number) => {
        setCurPage(page);
    }

    return <ModalWrapper 
        size="md" overlay={true} width={1200}
        onOverlayClick={() => { setAddressModalVisible(false) }}
        onEscKeyDown={() => { setAddressModalVisible(false) }}>
        <div className="w-full h-[10%] flex items-center px-[24px] bg-gray-100">
            <p className="font-bold text-[14px]">
                주소 검색
            </p>
        </div>
		{/* <InputForm title="검색어" 			value={search} 		editable={true}	name="search" 	onChange={handleChange} /> */}
        <div className="w-full h-[10%] flex items-center px-[24px]">
            <SearchForm value={search} setSearch={setSearch} onSearch={handleSearchClick} />
        </div>
		<p className="text-red-500 px-[24px] text-[12px] -mt-[12px]">
			{processMessage}
		</p>
        <div className="w-full max-w-[95%] mx-auto h-[70%] max-h-[70%] overflow-auto flex flex-col gap-[4px] p-[12px] border border-gray-200">
            {addressList.map((value, index) => <AddressItem
                key={index}
                data={value}
                onSelect={addressModalProps!.onSelect} />)}
        </div>
        <div className="flex w-full h-[10%] justify-center items-center gap-[4px]">
            <button className="w-[30px] h-[30px] bg-gray-200 rounded-[8px]" onClick={handlePrevClick}>
                <LeftOutlined />
            </button>
            {pageList.map((value) => {
                return <button key={value} className={`w-[30px] h-[30px] rounded-[8px] ${curPage === value ? 'bg-blue-dark text-white' : 'bg-gray-200'}`}
                    onClick={() => handlePageClick(value)}>
                    {value}
                </button>
            })}
            <button className="w-[30px] h-[30px] bg-gray-200 rounded-[8px]" onClick={handleNextClick}>
                <RightOutlined />
            </button>
        </div>
    </ModalWrapper>
}